module.exports = __webpack_public_path__ + "static/media/angel_chang.1b8dcdda.jpg";